import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

const getOnline = (): boolean => navigator.onLine

/**
 * Server and JSDOM have no network to report on. Assuming online keeps the
 * offline branch — which claims "showing the last close" — off a first paint
 * that has no evidence for it.
 */
const getOnlineOnServer = (): boolean => true

/**
 * `navigator.onLine`, kept current by the browser's `online`/`offline` events.
 *
 * Only `false` is evidence: the browser knows when it has no network interface
 * at all, but reports `true` for a connected-but-dead uplink and for a captive
 * portal. So read `false` as "offline" and `true` as "no idea" — a failed
 * request is what speaks for a dead network.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, getOnline, getOnlineOnServer)
}
